import R from 'ramda';
import commonConstants from 'ha/constants/commonConstants';
import diffDay from 'ha/helpers/hadate/diffDay';
import addMonths from 'ha/helpers/hadate/addMonths';

const { listingFlexibleDays } = commonConstants;

const calculateMinimumSelectedDays = R.memoize((startDate, minimalPeriod) => {
  if (!minimalPeriod) {
    return 0;
  }

  return (
    diffDay(addMonths(startDate, minimalPeriod), startDate) -
    listingFlexibleDays
  );
});

export default calculateMinimumSelectedDays;
